import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, CircularProgress, Divider, IconButton, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import Page from 'components/Page';

import * as TenantAction from 'actions/tenant-action';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import TenantToolbar from './tenant-toolbar';
import TenantSetting from './tenant-settings';

import PaymentForm from '../stripe/payment-form';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { initializeStripePayment } from 'services/tenant-service.js';
import NewUserForm from './new-user-form';
import DataDialog from 'components/dialogs/DataDialog';
import PageHeader from 'global/PageHeader';
import { EditOutlined, LockOutlined, MoreVert } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import Notificationbar from 'global/Notificationbar';
import TenantForm from './tenant-form';
import CTTabs from 'components/CTTabs';
import PasswordResetForm from './password-reset';
import OperationalExpense from './operational-expense';
import ThirdPartyIntegration from './integrations';
import EditUserForm from './edit-user-form';
import { FSConfig } from 'freightsmart-config';
import FTIcons from 'assets/icons/FTIcons';
import { tokens } from 'theme/tokens';

const stripePromise = loadStripe(FSConfig.stripePublicationKey);

const TABS = ['Users', 'Settings', 'Operational Expenses', 'Integrations'];

const TenantPage = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const dispatch = useDispatch();  
  const { tenant, users, expenses, categories, isProcessing, toast, scheduler } = props;
  const initState = {
    tenantModal: {
      tenantId: '',
      company: '',
      email: '',
      phone: '',
      accountPlan: '',
      status: '',
      mcNumber: '',
      dotNumber: '',
      businessModel: '',
      trucks: 0,
      street: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
    },
    userModal: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      role: '',
      permission: [],
    },
    passwordResetModal: {
      email: '',
      currentPassword: '',
      password: '',
      confirmPassword: '',
    },
    tenantSettingModal: {
      startOrderNumber: '',
      smsNotificationEnabled: false,
      emailNotificationEnabled: false,
      driverNotificationEnabled: false,
      eodOrderReportEnabled: false,
      eodInvoiceReportEnabled: false,
      eodPaymentReportEnabled: false,
      orderStatusMessageEnabled: false,
      invoiceGeneratedMessageEnabled: false,
      driverPaymentMessageEnabled: false,
    },
    expenseModal: {
      expenseName:'',
      category:'',
      categoryDescription:'',
      vendor:'',
      amount:'',
      paid:'',
      expenseDate:'',
      dueDate:'',
      lastPaymentDate:'',
      paymentMode:'',
      expenseStatus:'',
      recurring: 'MONTHLY',
      autoPayEnabled: false,
      notes:''
    }
  };
  const [tenantModal, setTenantModal] = useState(initState.tenantModal);
  const [userModal, setUserModal] = useState(initState.userModal);
  const [passwordResetModal, setPasswordResetModal] = useState(initState.passwordResetModal);
  const [operationalExpenseModal, setOperationalExpenseModal] = useState(initState.expenseModal);

  const [action, SetAction] = useState('Save');
  const [isTenantDialogOpen, setTenantDialogOpen] = useState(false);
  const [isNewUserFormDialogOpen, setNewUserDialogOpen] = useState(false);
  const [isEditUserDialogOpen, setEditUserDialogOpen] = useState(false);
  const [isEditUserRole, setEditUserRole] = useState(false);
  const [isPasswordResetDialogOpen, setPasswordResetDialogOpen] = useState(false);
  const [isOperationalExpenseFormOpen, setOperationalExpenseDialogOpen] = useState(false);  
  const [anchorEl, setAnchroEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  /* Stripe */
  const [clientSecret, setClientSecret] = useState('');
  const [isPaymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);

  useEffect(()=> {
    const tenantId = tenant.tenantId;
    dispatch(TenantAction.listExpenseCategories(tenantId));
    dispatch(TenantAction.listOperationalExpenses(tenantId));
  },[tabIndex, isOperationalExpenseFormOpen]);

  // const getExpenseStatusColor = (value) => {
  //   const { status } = theme;
  //   return value ? status.expense[value.toLowerCase()] : '#f0f0f0';
  // };

  /* Stripe Payment Dialog */
  const showPaymentDialog = (tenant) => {
    const tenantPaymentModel = {
      planType: tenant.accountPlan,
      amount: tenant.paymentAmount,
    };
    initializeStripePayment(tenantPaymentModel).then(res => {
      if (res && res.status === 200) {
        setClientSecret(res.data.clientSecret);
        setPaymentDialogOpen(true);
      } else {
        alert('Unable to setup payment. Please try again later');
      }
    });
  };

  const columns = [
    { field: 'id', headerName: 'Id' },
    { field: 'firstName', headerName: 'First name', flex: 1 },
    { field: 'lastName', headerName: 'Last name', flex: 1 },
    { field: 'username', headerName: 'Username', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    {
      field: 'role', headerName: 'Role', flex: 1, renderCell: (param) => {
        return param.row.role.forEach(element => {
          <Typography>{element}</Typography>;
        });
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <IconButton
              size='small'
              color={'primary'}
              aria-label='more'
              aria-controls='long-menu'
              onClick={(evt) => handleMenuClick(evt, params.row)}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id='long-menu'
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => { setAnchroEl(null); }}
            >
              <MenuItem key='edit' onClick={() => editUser(selectedRow)}><EditOutlined fontSize='small' color='primary' />&nbsp;&nbsp;Edit</MenuItem>
              <Divider />
              <MenuItem key='reset' onClick={() => resetUserPassword(selectedRow)}><LockOutlined fontSize='small' color='primary' />&nbsp;&nbsp;Change Password</MenuItem>
              <Divider />
              <MenuItem key='reset' onClick={() => editUserRole(selectedRow)}><LockOutlined fontSize='small' color='primary' />&nbsp;&nbsp;Change Role & Permissions</MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];

  const expenseColumns = [
    { field: 'id', headerName: 'Id' },
    { field: 'expenseName', headerName: 'Expense', flex: 1 },
    { field: 'vendor', headerName: 'Vendor', flex: 1 },
    { field: 'amount', headerName: 'Amount', flex: 1 },
    { field: 'paid', headerName: 'Paid', flex: 1 },
    { field: 'paymentMode', headerName: 'Pay Mode', flex: 1 },
    { field: 'expenseDate', headerName: 'Expense Date', flex: 1 },
    { field: 'dueDate', headerName: 'Due Date', flex: 1 },
    { field: 'lastPayment', headerName: 'Last Payment Date', flex: 1 },
    { field: 'autoPayEnabled', headerName: 'Auto Pay', flex: 1 },
    { field: 'notes', headerName: 'Notes', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        return (
          <IconButton onClick={() => editExpense(params.row)}>
            <FTIcons.EditIcon
              width={20}
              height={20}
              fill={colors.primary.main}
            />
          </IconButton>
        );
      },
    },    
  ];
  

  const saveTenantSetting = (tenantSetting, scheduler) => {
    dispatch(TenantAction.saveTenantSetting(tenantSetting));
    if (scheduler != null) {
      dispatch(TenantAction.createSchedule(scheduler));
    } else {
      dispatch(TenantAction.deleteSchedule());
    }
  };

  const editTenant = () => {
    const { tenantId, company, email, phone, accountPlan, status, mcNumber, dotNumber, trucks, street, city, state, zipcode, country } = tenant;
    const businessModel = tenant.tenantBusinessModel;
    const obj = { tenantId,
      company,
      email,
      phone,
      accountPlan,
      status,
      mcNumber,
      dotNumber,
      businessModel,
      trucks,
      street,
      city,
      state,
      zipcode,
      country
    };
    setTenantModal(obj);
    setTenantDialogOpen(true);
  };

  const editUser = (row) => {
    setUserModal({ ...row });
    setEditUserDialogOpen(true);
  };

  const editUserRole = (row) => {
    setUserModal({ ...row, role: row.role[0] });
    setEditUserRole(true);
    setEditUserDialogOpen(true);
  };

  const editExpense = (row) => {
    initState.expenseModal = {...row};
    initState.expenseModal.category = row.category.name;
    initState.expenseModal.description = row.category.description;
    setOperationalExpenseModal({ ...initState.expenseModal });
    SetAction('Update');
    setOperationalExpenseDialogOpen(true);
  };

  const deleteExpense = (row) => {

  }

  const resetUserPassword = (row) => {
    const isAuthorized = localStorage.ACTIVE_USER_EMAIL === row.email;
    if (isAuthorized) {
      setPasswordResetModal({...passwordResetModal, email: row.email });
      setPasswordResetDialogOpen(true);
    } else {
      const message = `You are not authorized to reset password for user: ${row.firstName} ${row.lastName}`;
      window.alert(message);
    }
  };

  const closeFormDialog = () => {
    dispatch(TenantAction.resetState('RESET_TOAST_STATE'));
    setTenantModal(initState.tenantModal);
    setUserModal(initState.userModal);
    setPasswordResetModal(initState.passwordResetModal);
    setOperationalExpenseModal(initState.expenseModal);
    SetAction('Save');
    setNewUserDialogOpen(false);
    setEditUserDialogOpen(false);
    setTenantDialogOpen(false);
    setPasswordResetDialogOpen(false);
    setOperationalExpenseDialogOpen(false);
  };

  const handleMenuClick = (evt, data) => {
    setSelectedRow(data);
    setAnchroEl(evt.currentTarget);
  };

  /* Stripe Payment Setting */
  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Page title='Profile'>
      <Box display={'flex'} justifyContent={'space-between'}>
        <PageHeader
          title='MY ACCOUNT'
          subTitle='Manage Your Company Profile'
        />
        <Notificationbar />
      </Box>
      <Box
        m='20px 0 0 0'
      >
        <TenantToolbar
          tenant={tenant}
          fnHandleEditTenantDialog={editTenant}
          fnOnPaymentHandler={() => showPaymentDialog(tenant)}
        />
      </Box>
      <Box
        m='20px 0 0 0'
        height='75vh'
      >
        <CTTabs
          labels={TABS}
          tabIndex={tabIndex}
          fnOnTabChangeHandler={(index) => setTabIndex(index)}
        />
        <Box
          hidden={tabIndex !== 0}
          height='75vh'
          marginTop={'20px'}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={() => setNewUserDialogOpen(true)}
          >
            {'New User'}
          </Button>
          <DataGrid
            rows={users}
            columns={columns}
            rowHeight={40}
            disableSelectionOnClick
          />
        </Box>
        <Box
          hidden={tabIndex !== 1}
          marginTop={'20px'}
        >
          {isProcessing ? <CircularProgress style={{ position: 'absolute', top: '50%', marginLeft: '50%' }} /> :
            <TenantSetting
              tenantSetting={tenant.tenantSetting || {}}
              scheduler={scheduler}
              toast={toast}
              fnOnSaveFormHandler={saveTenantSetting}
            />
          }
        </Box>
        <Box
          hidden={tabIndex !== 2}
          marginTop={'20px'}
        >
          <Box display={'flex'} justifyContent={'space-between'}>
            <Button
              variant='contained'
              color='primary'
              onClick={()=>setOperationalExpenseDialogOpen(true)}
            >
              {'New Expense'}
            </Button>
          </Box>
          <DataGrid
            columns={expenseColumns}
            rows={expenses}
            autoHeight={true}
          />
          <DataDialog
            title={'Operational Expense'}
            open={isOperationalExpenseFormOpen}
            toast={toast}
            isProcessing={isProcessing}
            onCloseHandler={closeFormDialog}
          >
            <OperationalExpense
              expenseForm={operationalExpenseModal}
              categories={categories}
              expenses={expenses}
              action={action}
              saveFormHandler={(form) => dispatch(TenantAction.saveOperationalExpense(tenant.tenantId, form))}
              updateFormHandler={(form) => dispatch(TenantAction.updateOperationalExpense(tenant.tenantId, form))}
            />
          </DataDialog>
        </Box>
        <Box
          hidden={tabIndex !== 3}
          height='75vh'
          marginTop={'20px'}
        >
          <ThirdPartyIntegration />
        </Box>        
      </Box>
      <DataDialog
        open={isNewUserFormDialogOpen}
        title='New User Form'
        isProcessing={isProcessing}
        toast={toast}
        onCloseHandler={closeFormDialog}
      >
        <NewUserForm
          action={action}
          user={userModal}
          saveFormHandler={(form) => dispatch(TenantAction.saveUser(form))}
          updateFormHandler={(form) => dispatch(TenantAction.updateUser(form))}
        />
      </DataDialog>
      <DataDialog
        open={isEditUserDialogOpen}
        title='Update User'
        isProcessing={isProcessing}
        toast={toast}
        onCloseHandler={closeFormDialog}
      >
        <EditUserForm
          action={action}
          user={userModal}
          isUpdatingUserRole={isEditUserRole}
          updateFormHandler={(form) => dispatch(TenantAction.updateUser(form))}
        />
      </DataDialog>      
      <DataDialog
        open={isTenantDialogOpen}
        title='Tenant'
        isProcessing={isProcessing}
        toast={toast}        
        onCloseHandler={closeFormDialog}
      >
        <TenantForm
          action={'Update'}
          tenant={tenantModal}
          updateFormHandler={(form) => dispatch(TenantAction.updateTenant(form))}
        />
      </DataDialog>
      <DataDialog
        open={isPasswordResetDialogOpen}
        title='Reset Password'
        isProcessing={isProcessing}
        toast={toast}
        onCloseHandler={closeFormDialog}
      >
        <PasswordResetForm
          resetPassword={passwordResetModal}
          fnOnPasswordResetHandler={form => dispatch(TenantAction.resetPasswordByAdmin(form))}
        />
      </DataDialog>
      <DataDialog
        open={isPaymentDialogOpen}
        title='Process Payment'
        isProcessing={isPaymentProcessing}
        onCloseHandler={() => setPaymentDialogOpen(false)}
      >
        {clientSecret && (
          <Elements options={options} stripe={stripePromise}>
            <PaymentForm
              planType={tenant.accountPlan}
              amount={tenant.paymentAmount}              
              clientSecret={clientSecret}
            />
          </Elements>)}
      </DataDialog>

    </Page>
  );
};

function mapStatesToProps(state) {
  const { tenant, user, users, expenses, categories, toast, isProcessing } = state.tenantReducer;
  const { scheduler, scheduleToast, isScheduleProcessing } = state.schedulerReducer;

  return {
    tenant,
    user,
    users,
    expenses,
    categories,
    scheduler,
    toast,
    isProcessing,
    scheduleToast,
    isScheduleProcessing,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(TenantAction, dispatch);
}

// Promote TenantPage from a component to a container - it needs to know
// about this new dispatch method, selectTenant
export default connect(mapStatesToProps, mapDispatchToProps)(TenantPage);